export default __webpack_public_path__ + "static/media/1204.72df356a.png";